import React, { useState, useEffect } from "react";
import CloseIcon from "@mui/icons-material/Close";
import BasicCustomTable from "../basicTable";
import CustomButton from "../elements/CustomButton/CustomButton";
import { useSnackbar } from "../SnackbarContext";
import axiosInstance from "../../configuration/request";
import { assignColumns } from "../../constants/rbacManagement";
import CustomAutocomplete from "../elements/CustomeAutocomplete";

const dropdownOptions = [
  {
    value: "1",
    name: "John Doe",
    email: "john@example.com",
    phone: "9876543210",
    label: "John Doe-john@example.com",
  },
  {
    value: "2",
    name: "Jane Smith",
    email: "jane@example.com",
    phone: "9123456780",
    label: "Jane Smith-jane@example.com",
  },
  {
    value: "3",
    name: "Alex Brown",
    email: "alex@example.com",
    phone: "9988776655",
    label: "alex@example.com-alex@example.com",
  },
];

function AssignRoleForm({ onClose, roleDetails, onSubmit }) {
  const showSnackbar = useSnackbar();
  const [assignEmployee, setAssignedEmployees] = useState([]);
  const [selected, setSeleced] = useState([]);
  const [employee, setEmployee] = useState([]);
  useEffect(() => {
    if (roleDetails?.selectedRow?.usersList?.length > 0) {
      const formattedRole = roleDetails?.selectedRow?.usersList?.map(
        (item) => ({
          value: item.id || "",
          name: item.name || "",
          email: item.email || "",
          phone: item.phone_number || "",
        })
      );
      setAssignedEmployees(formattedRole);
    }
    fetchEmployee();
  }, []);

  const fetchEmployee = async () => {
    try {
      let url = "";
      if (roleDetails?.userType === "business user" && roleDetails?.storeId) {
        url += `/customer/store/employees?userType=employee user&shopId=${roleDetails?.storeId}`;
      } else if (roleDetails?.userType === "admin") {
        url = `customer/users?usertype=${roleDetails?.userType}&isApproved=approved`;
      } else {
        url = "";
      }
      const res = await axiosInstance.get(url);
      const formattedEmployee = res?.data?.data?.map((item) => ({
        value: item.id || "",
        name: item.name || "",
        email: item.email || "",
        phone: item.phone_number || "",
        label: item.name + "-" + item.email,
      }));
      setEmployee(formattedEmployee);
    } catch (error) {
      showSnackbar("Something went wrong!", "error");
    }
  };

  const handleAssign = async () => {
    let payload = {
      userIds: assignEmployee.map((item) => item.value),
      roleId: roleDetails?.selectedRow?.id,
    };

    if (payload?.userIds?.length > 0) {
      try {
        const res = await axiosInstance.post("auth/rbac/assign-role", payload);
        onSubmit();
      } catch (error) {
        showSnackbar("Something went wrong!", "error");
      }
    } else {
      onSubmit();
    }
  };

  const handleSelect = (selectedValue) => {
    if (selectedValue) {
      setSeleced(selectedValue);

      setAssignedEmployees((prev) => {
        if (!prev.some((emp) => emp.value === selectedValue.value)) {
          return [...prev, selectedValue];
        }
        return prev;
      });
    } else {
      setSeleced(null);
    }
  };

  const handleRemove = async (row) => {
    const payload = {
      userIds: [row.value], // single user to revoke
      roleId: roleDetails?.selectedRow?.id,
    };

    try {
      await axiosInstance.delete("auth/rbac/revoke-role", { data: payload });
      // Remove from state only if API call is successful
      setAssignedEmployees((prev) =>
        prev.filter((emp) => emp.value !== row.value)
      );
      showSnackbar(`${row.name || row.email} revoked successfully`, "success");
    } catch (error) {
      showSnackbar("Failed to revoke role for this user", "error");
    }
  };

  return (
    <div className="pt-6 px-10">
      <div className="flex justify-between mb-6">
        <div className="text-lg font-[500]">Assign Role</div>
        <button
          className="text-gray-600 hover:text-black"
          onClick={onClose}
          aria-label="Close"
        >
          <CloseIcon />
        </button>
      </div>

      <div className="flex flex-col my-4 w-full justify-center items-center">
        <div className="w-full">
          <CustomAutocomplete
            label="Search/Assign User"
            value={selected}
            onChange={handleSelect}
            options={employee}
            multiple
          />
        </div>

        {assignEmployee.length > 0 && (
          <div className="w-full mt-4">
            <BasicCustomTable
              columns={assignColumns}
              rows={assignEmployee}
              colorHeader={false}
              onDelete={handleRemove}
              customClassHeader={"table-header-normal"}
              tableName="assign-employee"
            />
          </div>
        )}

        <div className="flex flex-col sm:flex-row justify-center items-center mt-8 mb-4 gap-3">
          <CustomButton
            onClick={onClose}
            customeClass="primary-custom-button w-full sm:w-[150px] h-[40px]"
          >
            Cancel
          </CustomButton>
          <CustomButton
            onClick={handleAssign}
            customeClass="gradient-button w-full sm:w-[150px] h-[40px]"
          >
            Assign
          </CustomButton>
        </div>
      </div>
    </div>
  );
}

export default AssignRoleForm;
